import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = 'boss_auth_token';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { refreshUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate('/login', { replace: true });
      return;
    }

    const sessionId = match[1];

    (async () => {
      try {
        const res = await fetch(`${API}/auth/google-session`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ session_id: sessionId }),
        });
        if (res.ok) {
          const data = await res.json();
          if (data.token) localStorage.setItem(TOKEN_KEY, data.token);
          await refreshUser();
          navigate('/account', { replace: true });
        } else {
          navigate('/login?error=google_auth_failed', { replace: true });
        }
      } catch {
        navigate('/login?error=google_auth_failed', { replace: true });
      }
    })();
  }, [navigate, refreshUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-sand" data-testid="auth-callback">
      <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-bush" />
    </div>
  );
}
